export interface BookbindingCollectionsRequest {
  parentCollectionId: number
  revision: number
  collections: {
    id: number
    holdingBranchCode: string
    collectionType: string
    handlingType: string
    revision: number
    _remove: boolean
  }[]
}

export function BookbindingCollectionsRequestToJSON(
  value: BookbindingCollectionsRequest
): any {
  return {
    parent_collection_id:
      value.parentCollectionId !== 0 ? value.parentCollectionId : undefined,
    revision: value.revision !== 0 ? value.revision : undefined,
    collections:
      value.collections.length > 0
        ? value.collections.map(collection => {
            return {
              id: collection.id !== 0 ? collection.id : undefined,
              holding_branch_code:
                collection.holdingBranchCode !== ''
                  ? collection.holdingBranchCode
                  : undefined,
              collection_type:
                collection.collectionType !== ''
                  ? collection.collectionType
                  : undefined,
              handling_type:
                collection.handlingType !== ''
                  ? collection.handlingType
                  : undefined,
              revision:
                collection.revision !== 0 ? collection.revision : undefined,
              _remove: collection._remove ?? false
            }
          })
        : undefined
  }
}
